import { Credentials } from "auth";
import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";

export type AuthResendVerificationEmail = "AUTH_RESEND_VERIFICATION_EMAIL";
export const AUTH_RESEND_VERIFICATION_EMAIL: AuthResendVerificationEmail = "AUTH_RESEND_VERIFICATION_EMAIL";

export type AuthResendVerificationEmailEnd = "AUTH_RESEND_VERIFICATION_EMAIL_END";
export const AUTH_RESEND_VERIFICATION_EMAIL_END: AuthResendVerificationEmailEnd = "AUTH_RESEND_VERIFICATION_EMAIL_END";

export interface AuthResendVerificationEmailAction extends Action {
    payload: {
        credentials: Credentials;
    };
    type: AuthResendVerificationEmail;
}

export function resendVerificationEmail(): ThunkAction<any, State, any, AuthResendVerificationEmailAction> {
    return (dispatch, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(resendVerificationEmailWithCredentials(credentials));
    };
}

function resendVerificationEmailWithCredentials(credentials: Credentials): AuthResendVerificationEmailAction {
    return {
        payload: {
            credentials
        },
        type: AUTH_RESEND_VERIFICATION_EMAIL
    };
}

export interface AuthResendVerificationEmailEndAction extends Action {
    payload: {
        error?: Error;
    };
    type: AuthResendVerificationEmailEnd;
}

export function resendVerificationEmailEnd(error?: Error): AuthResendVerificationEmailEndAction {
    return {
        payload: {
            error
        },
        type: AUTH_RESEND_VERIFICATION_EMAIL_END
    };
}